import React from 'react';
import { WithIcon } from './WithIcon';

export const IconWatchFilled = WithIcon(
  'Watch',
  '0 0 40 40',
  <path d="M33.3327 20.8108c0 .3388-.1758.6525-.461.8188L13.0106 33.213a.8868.8868 0 0 1-.4418.12.883.883 0 0 1-.4562-.1287c-.2757-.1688-.4466-.4763-.4466-.8088V9.2712c0-.3338.1697-.6413.4466-.81a.8741.8741 0 0 1 .8967-.0088l19.8612 11.5422c.2864.165.4622.4775.4622.8162Z" />
);
